import { Dropdown, DropdownItem } from '@swtorbit/ui/react';

interface UserMenuProps {
  username: string;
  logout: () => void;
  /** Open the global Content Library page (available to all admins). */
  onOpenContentLibrary: () => void;
  /** Open the admin's own profile (their timezone). */
  onOpenProfile: () => void;
  /** Whether to show the super-admin-only entries. */
  isSuperAdmin?: boolean;
  /** Open the Global Data view (super-admin only). Omitted = no entry (the area has no modules). */
  onOpenGlobalData?: () => void;
  /** Open the Admin Management view (super-admin only). */
  onOpenAdminManagement?: () => void;
}

export function UserMenu({ username, logout, onOpenContentLibrary, onOpenProfile, isSuperAdmin, onOpenGlobalData, onOpenAdminManagement }: UserMenuProps) {
  return (
    <Dropdown label={<span className="fs-sm">{username}</span>} trigger={{ variant: 'outline' }} end>
      <DropdownItem onClick={onOpenProfile}>Profile</DropdownItem>
      <DropdownItem onClick={onOpenContentLibrary}>Content Library</DropdownItem>

      {isSuperAdmin && onOpenGlobalData && (
        <DropdownItem onClick={onOpenGlobalData}>Global Data</DropdownItem>
      )}

      {isSuperAdmin && onOpenAdminManagement && (
        <DropdownItem onClick={onOpenAdminManagement}>Admin Management</DropdownItem>
      )}

      <DropdownItem onClick={logout}>Logout</DropdownItem>
    </Dropdown>
  );
}
